import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  paddingTabs: {
    padding: '5em',
    // overflow: "auto",
    [theme.breakpoints.only('xs')]: {
      padding: '1em',
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'sticky', // Mantiene los botones visibles al hacer scroll
    bottom: 0, // Se pega al final del contenedor
    backgroundColor: 'white', // Para que no se mezcle con el contenido
    paddingTop: '1.5rem', // Espacio alrededor de los botones
    zIndex: 10, // Asegura que esté por encima del contenido
  },
  buttonsHome: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute', // Mantiene los botones visibles al hacer scroll
    bottom: '1rem', // Se pega al final del contenedor
    backgroundColor: 'white', // Para que no se mezcle con el contenido
    paddingTop: '0.75rem', // Espacio alrededor de los botones
    zIndex: 10, // Asegura que esté por encima del contenid
    right: '1rem',
    width: '100%',
  },
}))

export default useStyles
